import api from './api';

export type TechCategory =
  | 'Security'
  | 'DevOps'
  | 'Monitoring'
  | 'Data'
  | 'Platform'
  | 'Infrastructure'
  | 'Testing'
  | 'Other';

export interface TechStackItem {
  _id: string;
  name: string;
  acronym?: string;
  category: TechCategory;
  description?: string;
  benefit?: string;
  url?: string;
  iconUrl?: string;
  githubUrl?: string;
  order: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTechStackItem {
  name: string;
  acronym?: string;
  category: TechCategory;
  description?: string;
  benefit?: string;
  url?: string;
  iconUrl?: string;
  githubUrl?: string;
  order?: number;
  isActive?: boolean;
}

export interface UpdateTechStackItem extends Partial<CreateTechStackItem> {}

const base = '/tech-stack-items';

const techStackService = {
  async list(q?: string): Promise<TechStackItem[]> {
    const res = await api.get(`${base}`, { params: q ? { q } : undefined });
    return res.data.data as TechStackItem[];
  },
  async create(payload: CreateTechStackItem): Promise<TechStackItem> {
    const res = await api.post(`${base}`, payload);
    return res.data.data as TechStackItem;
  },
  async update(id: string, payload: UpdateTechStackItem): Promise<TechStackItem> {
    const res = await api.put(`${base}/${id}`, payload);
    return res.data.data as TechStackItem;
  },
  async remove(id: string): Promise<void> {
    await api.delete(`${base}/${id}`);
  },
};

export default techStackService;
